import React from "react";
import { connect } from "react-redux";
import { listadosOps } from "../../ducks/listados";
import Tabla from "./listadoBajas/Tabla";
import {
  Transition,
  Container,
  Segment,
  Header,
  Button
} from "semantic-ui-react";

class ListadoBajas extends React.Component {
  state = { visible: false };

  componentDidMount() {
    this.setState({ visible: true });
    this.props.obtenerListadoBajas();
  }

  handleVolver = () => this.props.history.goBack();

  render() {
    return (
      <Transition.Group animation="scale" duration={250}>
        {this.state.visible && (
          <Container textAlign="center">
            <Segment>
              <Button
                content="Cerrar"
                floated="right"
                color="pink"
                icon="cancel"
                onClick={this.handleVolver}
              />

              <Header>Listado de Bajas</Header>
            </Segment>
            <Tabla bajas={this.props.listadoBajas} />
          </Container>
        )}
      </Transition.Group>
    );
  }
}

const toProps = (state, ownProps) => ({
  listadoBajas: state.listados.listadoBajas
});

const actions = {
  obtenerListadoBajas: listadosOps.obtenerListadoBajas
};

export default connect(toProps, actions)(ListadoBajas);



// WEBPACK FOOTER //
// ./src/pages/listados/ListadoBajas.jsx